<template>
  <div class="we">
      <div class="me">
          <img src="../assets/me.png" alt="">
          <img src="../assets/me01.png" alt="">
          <img src="../assets/me02.png" alt="">
          <img src="../assets/me03.png" alt="">
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='less'>

</style>